import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { AppRoutes } from '../AppRoutes';

const LoginPage = lazy(() =>
  import('@/pages/auth').then((module) => ({
    default: module.LoginPage,
  }))
);

// const RegisterPage = lazy(() =>
//   import('@/pages/auth').then((module) => ({
//     default: module.RegisterPage,
//   }))
// );

export const authRouter: RouteObject[] = [
  {
    path: AppRoutes.LOGIN,
    element: <LoginPage />,
  },
  // {
  //   path: AppRoutes.REGISTER,
  //   element: <RegisterPage />,
  // },
];
